/**
 *
 * Recent Deposits Service
 *
 * Used to get the recent deposits for a given account.
 * Calls the same search endpoint as the search service.
 */
import { FAILURE, LOADING, NAMESPACE, NOT_ASKED } from './constants';
import reducer from './reducer';
import sagas from './sagas';
import { selectStatus, selectResults, selectError, selectApexAccountNumber } from './selectors';
import { searchRequest } from './actions';

// The searchRequest() constitutes the external API for this service.
// Calling this function initiates a request.
export {
  FAILURE,
  LOADING,
  NAMESPACE,
  NOT_ASKED,
  reducer,
  sagas,
  selectApexAccountNumber,
  selectStatus,
  selectResults,
  selectError,
  searchRequest,
};



// WEBPACK FOOTER //
// ./src/services/recentDeposits/index.js